var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AdditionalJobItemUrl, AdditionalJobItemsListUrl, VIGetPeriodicParts, VIUpsertCustomerVoiceToJobItemUrl, ViewEstimateUrl, getComplaintListUrl, getSaveStandaredJobdUrl, getVehicleByInspectionIdByUrl, standaredJobListSaveUrl, upsertPMPartsUrl } from '../../api/url';
import { MuiStack } from '../../components';
import { APISchema, EParentModuleName, ESystemName, StatusEnum } from '../../constants';
import { showLoader } from '../../redux/commonSlice';
import { getByIdAPI } from '../../redux/crudSlice';
import { useAppDispatch } from '../../store/hooks';
import TaskDetailsComponent from '../commonViews/taskDetails/taskDetails';
import { systemColor } from '../../theme/systemColor';
var TaskDetailsVehicleInspection = function () {
    var inspectionId = useParams().inspectionId;
    var dispatch = useAppDispatch();
    var _a = useState(false), disableState = _a[0], setDisableState = _a[1];
    useEffect(function () {
        inspectionDetails();
    }, []);
    var inspectionDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload2, result, _result$payload3, _result$payload4, isDisabled, _estimateResponse$pay, _estimateResponse$pay2, _estimateResponse$pay3, requestBody, estimateResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "ModuleDetailsGetById",
                            url: getVehicleByInspectionIdByUrl(inspectionId !== null && inspectionId !== void 0 ? inspectionId : "")
                        }))];
                case 1:
                    result = _a.sent();
                    if (!((result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 || (_result$payload = _result$payload.value) === null || _result$payload === void 0 ? void 0 : _result$payload.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.success)) return [3 /*break*/, 4];
                    isDisabled = [StatusEnum.Converted, StatusEnum.Cancelled, StatusEnum.Closed].includes((result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.data) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.Key) || "");
                    if (!((result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.value) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.data) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.Key) === StatusEnum.Converted)) return [3 /*break*/, 3];
                    requestBody = {
                        "PreJobCardDocumentId": inspectionId,
                        "HasChild": true
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: ViewEstimateUrl,
                            request: requestBody
                        }))];
                case 2:
                    estimateResponse = _a.sent();
                    if (estimateResponse !== null && estimateResponse !== void 0 && (_estimateResponse$pay = estimateResponse.payload) !== null && _estimateResponse$pay !== void 0 && (_estimateResponse$pay = _estimateResponse$pay.data) !== null && _estimateResponse$pay !== void 0 && _estimateResponse$pay.PreJobCardDocumentId && estimateResponse !== null && estimateResponse !== void 0 && (_estimateResponse$pay2 = estimateResponse.payload) !== null && _estimateResponse$pay2 !== void 0 && _estimateResponse$pay2.success && (estimateResponse === null || estimateResponse === void 0 || (_estimateResponse$pay3 = estimateResponse.payload) === null || _estimateResponse$pay3 === void 0 ? void 0 : _estimateResponse$pay3.statusCode) == 200) {
                        if ((estimateResponse === null || estimateResponse === void 0 ? void 0 : estimateResponse.payload.data.Key) === StatusEnum.ApprovalPending || (estimateResponse === null || estimateResponse === void 0 ? void 0 : estimateResponse.payload.data.Key) === StatusEnum.Created || (estimateResponse === null || estimateResponse === void 0 ? void 0 : estimateResponse.payload.data.Key) === StatusEnum.Error) {
                            isDisabled = false;
                        }
                        else {
                            isDisabled = true;
                        }
                    }
                    _a.label = 3;
                case 3:
                    setDisableState(isDisabled);
                    _a.label = 4;
                case 4:
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        paddingTop: 1,
        width: '100%',
        bgcolor: systemColor.backgroundColor
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        paddingBottom: 1,
        width: '100%'
    }, /*#__PURE__*/ React.createElement(TaskDetailsComponent, {
        parentModuleName: EParentModuleName.Inspection,
        getSavedAddiionalJobUrl: AdditionalJobItemsListUrl,
        saveAdditionalJobsUrl: AdditionalJobItemUrl,
        SaveStandaredJobUrl: standaredJobListSaveUrl,
        getSavedStandaredJobUrl: getSaveStandaredJobdUrl,
        parentModuleDocumentId: inspectionId !== null && inspectionId !== void 0 ? inspectionId : '',
        getCustomerComplaintListUrl: getComplaintListUrl,
        saveTranslateToJobItemUrl: VIUpsertCustomerVoiceToJobItemUrl,
        apiRequestParam: APISchema.Inspection,
        getSavedPeriodicPartsUrl: VIGetPeriodicParts,
        upsertPMPartsUrl: upsertPMPartsUrl(APISchema.Inspection),
        apiRequestPayload: {
            InspectionId: inspectionId !== null && inspectionId !== void 0 ? inspectionId : ""
        },
        SystemName: ESystemName.Inspection,
        createAndEditFlow: {
            isInspection: "Update"
        },
        isDisabled: disableState,
        documentId: inspectionId
    })));
};
export default TaskDetailsVehicleInspection;
